export enum PRODUCT_AVAILABLE_PATH_TABS {
  BASE = 'base',
  PROPERTIES = 'properties',
  TECHNOLOGY = 'technology',
  PRICING = 'pricing',
  ORDERS = 'orders',
  VARIANTS = 'variants',
}
